// extracted by mini-css-extract-plugin
export default {"comments":"-7a5M","comment":"f7JTb","divider":"H-8+c"};